import { DOCUMENT, inject, Inject, Injectable, Renderer2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DarkModeService {

    private _darkMode$ = new BehaviorSubject<boolean>(false);
    public darkMode$ = this._darkMode$.asObservable();

    constructor(
    ) { }

    public setDarkMode(value: boolean) {
        this._darkMode$.next(value);
        // console.log('Dark mode set to:', value);



    }

}
